import { CommunityServicesEntity, NameUtils } from '@oh-vcp/components-common';
import React, { FC } from 'react';
import { Link, Typography } from '@mui/material';
import { HandHoldingHeartIcon } from '@oh-vcp/components-ui/src/icons';
import { StyledCardHeaderSubTitle } from '@oh-vcp/components-ui/src/StyledComponents';
import MapService from '@oh-vcp/components-ui/src/services/MapService';
import HtmlContent from '@oh-vcp/components-ui/src/htmlContent/HtmlContent';
import PhoneLink from '@oh-vcp/components-ui/src/phoneLink/PhoneLink';
import SearchResultCardHeader from '../searchResultCardHeader/SearchResultCardHeader';

interface CommunityServicesListHeaderCardProps {
  communityService: CommunityServicesEntity;
  isCompact?: boolean;
  highlightText?: string | null;
}

const CommunityServicesListHeaderCard: FC<CommunityServicesListHeaderCardProps> = ({
  communityService,
  isCompact,
  highlightText
}) => {
  const {
    serviceName,
    parentServiceName,
    address,
    city,
    postalCode,
    province,
    officePhone,
    id,
    highlight
  } = communityService;
  const isPhoneHtml = Boolean(officePhone && officePhone.indexOf('<') > -1);
  const url = `/communityservices/${id}`;
  return (
    <SearchResultCardHeader
      title={NameUtils.makeCommunityServiceName(serviceName, parentServiceName)}
      secondaryTitle={parentServiceName}
      icon={HandHoldingHeartIcon}
      viewBox="-4 -4 35 35"
      url={url}
      highlightText={highlightText}
      highlight={highlight}
      isCompact={isCompact}>
      <StyledCardHeaderSubTitle variant="body1">
        <Link
          target="_blank"
          onClick={(e) => e.stopPropagation()}
          href={MapService.getMapUrl({
            address,
            city,
            postalCode,
            province
          })}>
          {NameUtils.makeAddressName(address, city, province, postalCode)}
        </Link>
      </StyledCardHeaderSubTitle>
      <StyledCardHeaderSubTitle variant="body1">
        {isPhoneHtml && (
          <Typography color="primary.main">
            <HtmlContent htmlString={officePhone} />
          </Typography>
        )}
        {!isPhoneHtml && <PhoneLink phoneNumber={officePhone} variant="body1" />}
      </StyledCardHeaderSubTitle>
    </SearchResultCardHeader>
  );
};

export default CommunityServicesListHeaderCard;
